import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ToastProps {
  message: string;
  show: boolean;
  type?: 'success' | 'error';
}

const Toast: React.FC<ToastProps> = ({ message, show, type = 'error' }) => {
  const bgColor = type === 'error' ? 'bg-red-500/90' : 'bg-green-500/90';

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
      }}
    >
      <AnimatePresence>
        {show && (
          <motion.div
            initial={{ opacity: 0, y: -30, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -30, scale: 0.9 }}
            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          >
            <div className={`rounded-full px-6 py-3 text-white font-bold shadow-2xl backdrop-blur-md ${bgColor}`}>
              {message}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Toast;
